import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class GeneralService {

  constructor(
    public router: Router
  ) { }

  getUrlParam(name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results == null) {
      return null;
    }
    else {
      return decodeURI(results[1]) || 0;
    }
  }

  public loginUser() {
    this.router.navigate(["/enetassess"]);
  }

  public goToEnetassess() {
    this.router.navigate(["/enetassess"]);
  }

  public goToFeedback(){
    this.router.navigate(["/feedback"]);
  }

  public logoutUser() {
    window.location.href = "login";
  }

  public launchExam() {
    
    this.router.navigate(["/loadexam"]);
  }

  public launchExamQuestions() {
    this.router.navigate(["/questions"]);
  }
}
